import { Component, computed, input } from '@angular/core';
import { RidEggCarton } from '../rid-egg-carton/rid-egg-carton';

@Component({
  selector: 'rid-egg-cartons',
  templateUrl: './rid-egg-cartons.html',
  imports: [RidEggCarton],
})
export class RidEggCartons {
  public readonly eggs = input.required<number>();
  public readonly fillColor = input('#10b981');
  protected readonly cartons = computed(() => Math.ceil(this.eggs() / 10));
}
